export const DEFAULT_LOCALE = 'en-US';

export const BUNDLE_NAME = {
  CORE: 'core',
  HMD_FEEDBACK: 'hmdFeedback',
  HOMEPAGE: 'homepage',
  LEARNING_MODULE: 'learningModule',
  LEARNING_PATHWAY: 'learningPathway',
  NAVIGATION: 'navigation',
  SEARCH: 'search',
  WEBINAR: 'webinar',
  TOPIC: 'topic',
};

export const HMD_FEEDBACK_STRING_ID = {
  THUMB_FEEDBACK_TITLE: 'was-this-content-helpful',
  GENERAL_ERROR_MESSAGE: 'general-error-message',
  NO_OPTION_SELECTED_ERROR_MESSAGE: 'no-option-selected-error-message',
  NO_FEEDBACK_PROVIDED_ERROR_MESSAGE: 'no-feedback-provided-error-message',
  NEGATIVE_FEEDBACK_TITLE_TEXT: 'negative-feedback-title-text',
  SUBMIT_TEXT: 'submit-text',
  SUCCESS_FEEDBACK_TEXT: 'success-feedback-text',
  SUCCESS_FEEDBACK_AGAIN_TEXT: 'success-feedback-again-text',
  COMMENT_PLACEHOLDER: 'feedback-positive-comment-text',
  POSITIVE_FEEDBACK_COMMENT_TITLE: 'feedback-positive-text',
  NEGATIVE_COMMENT_PLACEHOLDER: 'feedback-negative-comment-text',
  COMMENT_PII_WARNING: 'feedback-comment-pii-warning',
  PII_DISCLAIMER_LABEL: 'feedback-pii-disclaimer-label',
  PII_DISCLAIMER_DESCRIPTION: 'feedback-pii-disclaimer-description',
  CHARACTERS_REMAINING: 'feedback-characters-remaining',
  FEEDBACK_NEGATIVE_OPTION_1: 'feedback-negative-option1',
  FEEDBACK_NEGATIVE_OPTION_2: 'feedback-negative-option2',
  FEEDBACK_NEGATIVE_OPTION_3: 'feedback-negative-option3',
  FEEDBACK_NEGATIVE_OPTION_4: 'feedback-negative-option4',
  FEEDBACK_NEGATIVE_OPTION_5: 'feedback-negative-option5',
};

export const LEARNING_MODULE_STRING_ID = {
  MODULE_DESCRIPTION_SUMMARY_TEXT: 'module-description-summary-text',
  PDF_LANGUAGE_SELECTOR_TEXT: 'pdf-language-selector',
  VIDEO_LANGUAGE_SELECTOR_TEXT: 'video-language-selector',
  VIDEO_ALTERNATIVE_LINK: 'video-alternative-link',
  DOWNLOAD_PDF_TEXT: 'download-pdf-text',
  MODULE_DESCRIPTION_BOX_SUBCONTENT_TITLE: 'module-description-box-subcontent-title',
  MORE_INFORMATION_TITLE: 'more-information-title',
};

export const LEARNING_PATHWAY_STRING_ID = {
  LEARNING_PATHWAY_PAGE_HEADER_PATH_TYPE: 'learning-pathway-page-header-path-type',
  LEARNING_PATHWAY_FEATURED_HEADER_TEXT: 'learning-pathway-featured-header-text',
  LEARNING_PATHWAY_TOTAL_SECTIONS: 'learning-pathway-total-sections',
  LEARNING_PATHWAY_TOTAL_MODULES: 'learning-pathway-total-modules',
  LEARNING_PATHWAY_DURATION: 'learning-pathway-duration',
  LEARNING_PATHWAY_PDF_PAGES: 'learning-pathway-pdf-pages',
  LEARNING_PATHWAY_SECTION_LABEL: 'learning-pathway-section-label',
  LEARNING_PATHWAY_TOTAL_MODULES_LABEL: 'learning-pathway-total-modules-label',
};

export const HOMEPAGE_STRING_ID = {
  TOPICS_CAROUSEL_TITLE: 'home-page-topics-carousel-title',
  LEARNING_PATHWAY_CAROUSEL_TITLE: 'home-page-learning-pathway-carousel-title',
  LEARN_MORE_BUTTON: 'learn-more-button',
  PRIME_DAY_HOLIDAY_CAROUSEL_TITLE: 'homepage-advertise-and-grow-title',
  PRIME_DAY_HOLIDAY_CAROUSEL_DESCRIPTION: 'homepage-advertise-and-grow-description',
  PEER_TO_PEER_CAROUSEL_TITLE: 'homepage-carousel-peer-to-peer-title',
  PEER_TO_PEER_CAROUSEL_DESCRIPTION: 'homepage-carousel-peer-to-peer-description',
  SEO_TITLE: 'homepage-seo-title',
  SEO_DESCRIPTION: 'homepage-seo-description',
};

export const NAVIGATION_STRING_ID = {
  SEARCH_PLACEHOLDER: 'search_placeholder',
  SU_LABEL: 'nav_su_label',
  WEBINAR: 'nav_live_events',
  DROPDOWN_BUTTON_ERROR_HEADER: 'nav_topics_error_header',
  DROPDOWN_BUTTON_ERROR_DESCRIPTION: 'nav_topics_error_description',
  DROPDOWN_BUTTON_NO_OPTIONS: 'nav_topics_no_option',
  DROPDOWN_BUTTON_TOPICS: 'nav_topics',
};

export const CORE_STRING_ID = {
  ACTION_SEARCH: 'action_search',
  ACTION_START_COURSE: 'action_start_course',
  ACTION_TAKE_COURSE: 'action_take_course',
};

export const SEARCH_STRING_ID = {
  SEARCH_RESULTS_COUNT: 'search_results_count',
  AUTOCOMPLETE_FAILURE_MESSAGE: 'autocomplete_failure_message',
  AUTOCOMPLETE_LOADING_MESSAGE: 'autocomplete_loading_message',
};

export const WEBINAR_STRING_ID = {
  // Page header
  UPCOMING_WEBINARS_TITLE: 'upcoming-webinar-list',
  NO_UPCOMING_WEBINAR_TITLE: 'no_upcoming_live_webinars',

  // Webinar card
  BANNER_TEXT: 'su_webinar',
  SESSION_OVERVIEW_TEXT: 'session-overview-live-webinar',
  REGISTER_BUTTON_TEXT: 'register-join-live-webinar',
  JOIN_BUTTON_TEXT: 'join-live-webinar',
  ALREADY_REGISTERED_TEXT: 'already-registered-webinar',

  // Webinar registration modal
  MODAL_TITLE_TEXT: 'upcoming-webinar-registration',
  MODAL_SUCCESS_TITLE_TEXT: 'thank-you-register-live-webinar',
  MODAL_ERROR_TITLE_TEXT: 'su-webinar-registration-failure-title',
  MODAL_ERROR_MESSAGE_TEXT: 'su-webinar-registration-failure-description',
  MODAL_SUCCESS_MESSAGE_TEXT: 'confirmation-live-webinar',
  CANCEL_BUTTON_TEXT: 'cancel-live-webinar',
  CLOSE_BUTTON_TEXT: 'close_live_webinar',
};

export const TOPIC_STRING_ID = {
  INTERACTIVE_BANNER_TITLE: 'interactive-banner-title',
  INTERACTIVE_BANNER_DESCRIPTION: 'interactive-banner-description',
  INTERACTIVE_BANNER_BUTTON: 'interactive-banner-button',
};
